import React from 'react';

const TopBar = ({ title, onBack }) => {
  return (
    <div className="flex items-center gap-4 mb-8">
      {onBack && (
        <button onClick={onBack} className="p-2 hover:bg-gray-100 rounded-lg transition">
          <svg className="w-6 h-6 text-[#0C1D40]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}
      {title && <h1 className="text-xl font-bold text-[#0C1D40]">{title}</h1>}
    </div>
  );
};

export default TopBar;